/**
 * Fetches search suggestions from the /api/search endpoint.
 *
 * Returns up to `limit` results, or an empty array when:
 * - The response is not OK (non-2xx status)
 * - The response body is empty or not valid JSON
 * - A network error occurs
 *
 * Pass an AbortSignal to cancel the request when superseded by a newer call.
 * Aborted requests re-throw the AbortError — callers should handle it.
 */
export async function fetchSearchSuggestions(keyword: string, limit = 6, signal?: AbortSignal): Promise<any[]> {
  try {
    const encodedKeyword = encodeURIComponent(keyword)
    const resp = signal
      ? await fetch(`/api/search?keyword=${encodedKeyword}`, { signal })
      : await fetch(`/api/search?keyword=${encodedKeyword}`)
    if (!resp.ok) {
      return []
    }
    const results = await resp.json()
    return results.slice(0, limit)
  } catch (e: any) {
    // Re-throw abort errors so callers can distinguish them from real failures
    if (e?.name === 'AbortError') throw e
    return []
  }
}
